import React, { useState } from "react";
import styled from "styled-components";
import { Link } from "gatsby";

import NavbarLinks from "./NavbarLinks";

const HeaderWrapper = styled.header`
  height: 10vh;
  width: 100vw;
  display: flex;
  position: fixed;
  background-color: #fff;
  margin: 0 auto;
  padding: 0 10vw;
  top: 0;
  left: 0;
  justify-content: space-between;
  border-bottom: 1px solid #e0e0e0;
  z-index: 2;
  transition: 350ms;
  align-self: center;

  @media (max-width: 768px) {
    position: fixed;
    height: 8vh;
    padding: 0 5vw;
  }
`;

const BlogTitle = styled.h1`
  margin: 0;
  padding: 0;
  line-height: 75px;
  font-size: 20px;
  font-weight: 100;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  grid-template-rows: 75px;
  & > p {
    padding: 50px 0 0 10px;
  }
  & > a {
    height: 75px;
    display: flex;
    align-items: center;
  }
`;

interface ToggleProps {
  mobileNavOpened: boolean;
  onClick(): void;
}

const Toggle = styled.div<ToggleProps>`
  display: none;
  height: 100%;
  cursor: pointer;
  padding: 0 10vw;

  @media (max-width: 768px) {
    display: flex;
    padding: 0 15px;
  }
`;

interface NavboxProps {
  readonly open?: boolean;
}
const Navbox = styled.div<NavboxProps>`
  display: flex;
  height: 100%;
  justify-content: flex-end;
  align-items: center;

  @media (max-width: 768px) {
    flex-direction: column;
    position: fixed;
    width: 100%;
    justify-content: flex-start;
    padding-top: 10vh;
    background-color: #fff;
    transition: all 0.3s ease-in;
    top: 8vh;
    left: ${(props) => (props.open ? "-100%" : "0")};
  }
`;

interface HamburgerProps {
  readonly open?: boolean;
}

const Hamburger = styled.div<HamburgerProps>`
  background-color: #0077c8;
  width: 30px;
  height: 5px;
  border-radius: 5px;
  transition: all 0.3s linear;
  align-self: center;
  position: relative;

  transform: ${(props) => (props.open ? "rotate(45deg)" : "inherit")};

  ::before,
  ::after {
    content: "";
    width: 30px;
    height: 5px;
    background-color: #0077c8;
    border-radius: 5px;
    position: absolute;
    transition: all 0.3s linear;
  }

  ::before {
    transform: ${(props) =>
      props.open ? "rotate(-90deg) translate(-10px, 0px)" : "rotate(0deg)"};
    top: -10px;
  }

  ::after {
    opacity: ${(props) => (props.open ? "0" : "1")};
    transform: ${(props) => (props.open ? "rotate(90deg) " : "rotate(0deg)")};
    top: 10px;
  }
`;

const Header = () => {
  const [mobileNavOpened, setMobileNavOpened] = useState(false);
  return (
    <HeaderWrapper>
      <BlogTitle>
        <Link to={"/"}>
          <img src="/logo.svg" />
        </Link>
        <p>기술 블로그</p>
      </BlogTitle>
      <Toggle
        mobileNavOpened={mobileNavOpened}
        onClick={() => setMobileNavOpened(!mobileNavOpened)}
      >
        {mobileNavOpened ? <Hamburger open /> : <Hamburger />}
      </Toggle>
      {mobileNavOpened ? (
        <Navbox>
          <NavbarLinks />
        </Navbox>
      ) : (
        <Navbox open>
          <NavbarLinks />
        </Navbox>
      )}
    </HeaderWrapper>
  );
};

export default Header;
